
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../data/gridColumnType";

const initState = {
  projectId: '',
}

const TeamProjectFormData = {
  name: "Team Project Form",
  initialState: initState,
  section: [
    {
      sectionId: 'TeamProject',
      title: "Team Project Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "projectId",
          label: "Project Name",
          Field_Name: "project name",
          fieldType: FormFieldTypes.SELECT,
          dataField: "projectId",
          isMultiSelect: true,
          fieldSetting: {
            placeholder: "Please Select Project Name",
            isMultiSelect: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 validation-left-0",
          },
        }
      ]
    }
  ]
}

export const TeamProjectGridConfig = {
  columns: [
    {
      name: "Project Name",
      fieldName: "projectName",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowDelete: true,
      },
    },
  ],
}

export default TeamProjectFormData;